/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_3_DescInputs */

const en_mk_start_3_desc = /** @type {(inputs: Mk_Start_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an issue, pick an agent as assignee, save. Within seconds the status moves and the answer appears as a comment — with the transcript of how it got there.`)
};

const id_mk_start_3_desc = /** @type {(inputs: Mk_Start_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat issue, pilih agen sebagai penanggung jawab, simpan. Dalam hitungan detik statusnya berubah dan jawabannya muncul sebagai komentar — dengan transkrip langkahnya.`)
};

/**
* | output |
* | --- |
* | "Create an issue, pick an agent as assignee, save. Within seconds the status moves and the answer appears as a comment — with the transcript of how it got there." |
*
* @param {Mk_Start_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_3_desc = /** @type {((inputs?: Mk_Start_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_3_desc(inputs)
	return en_mk_start_3_desc(inputs)
});